import { render, staticRenderFns } from "./siren.vue?vue&type=template&id=d6537336"
import script from "./siren.vue?vue&type=script&lang=js"
export * from "./siren.vue?vue&type=script&lang=js"
import style0 from "./siren.vue?vue&type=style&index=0&id=d6537336&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports